<template>
  <div class="p-message-edit p-message-edit--message-group">
    <div class="c-title c-title--left">
      <div class="c-title__text u-fs24">テスト名を登録する</div>
      <div class="c-text u-fs--s">A/Bテストを管理する名前を入力してください</div>
    </div>
    <div class="p-message-edit-list p-message-edit-list--first">
      <div class="p-message-edit-list__item">
        <div class="c-input u-w100p">
          <div class="c-input__title">
            <span class="c-input__text c-input__text--required">【必須】</span>テスト名</div>
          <input
            v-model="abtestName"
            class="c-input__item"
            type="text"
            name="test_name"
            value=""
            placeholder="テスト名を入力してください"
          />
          <div class="c-error c-error--balloon">
            <div class="c-error__text"></div>
          </div>
        </div>
      </div>
      <div class="p-message-edit-list__item">
        <div class="c-input u-w100p">
          <div class="c-input__title">
            <span class="c-input__text c-input__text--required">【必須】</span>テストする内容を具体的なメモとして残しておきましょう</div>
          <input
            v-model="memo"
            class="c-input__item"
            type="text"
            name="memo"
            value=""
            placeholder="メモを入力してください"
          />
          <div class="c-error c-error--balloon">
            <div class="c-error__text"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: Object,
  },
  emits: ['update:modelValue'],
  data: function () {
    return {};
  },
  computed: {
    abtestName: {
      get() {
        return this.modelValue.abtestName;
      },
      set(abtestName) {
        this.updateValue({
          abtestName
        });
      }
    },
    memo: {
      get() {
        return this.modelValue.memo;
      },
      set(memo) {
        this.updateValue({
          memo
        });
      }
    },
  },
  methods: {
    updateValue(target) {
      // 親のv-modelを更新
      this.$emit('update:modelValue', {
        ...this.modelValue,
        ...target
      })
    },
    validate: function(errors) {
      if(!this.abtestName){
        errors['test_name'] = 'テスト名を入力してください';
      }

      if(!this.memo){
        errors['memo'] = 'メモを入力してください';
      }
    },
  },
}
</script>
